import React from 'react';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  children: React.ReactNode;
  withIcon?: boolean;
}
export function Button({
  variant = 'primary',
  size = 'lg',
  children,
  className = '',
  withIcon = false,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-semibold transition-all duration-300 rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-[#BC6C25] hover:bg-[#A45D1E] text-white shadow-lg hover:shadow-xl hover:-translate-y-0.5 focus:ring-[#BC6C25]',
    secondary: 'bg-[#2D6A4F] hover:bg-[#1B4332] text-white shadow-md hover:shadow-lg hover:-translate-y-0.5 focus:ring-[#2D6A4F]',
    outline: 'border-2 border-[#2D6A4F] text-[#2D6A4F] hover:bg-[#2D6A4F] hover:text-white'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} {...props} data-id="element-172">
      {children}
      {withIcon && <ArrowRight className="ml-2 h-5 w-5" data-id="element-173" />}
    </button>;
}